import type { FC } from 'react';

import FileViewer from '@zen/Components/FileViewer';
import { Modal } from '@zen/DesignSystem';

interface Props {
  fileTitle: string;
  fileUrl: string;
  isOpen: boolean;
  onClosePreview: () => void;
}

const DocumentPreviewModal: FC<Props> = (props) => {
  const { fileTitle, fileUrl, isOpen, onClosePreview } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClosePreview} tagline={fileTitle} title="Preview document" width="full">
      <div className="p-5 rounded-sm bg-grey-lightest">
        <FileViewer fileUrl={fileUrl} />
      </div>
    </Modal>
  );
};

export default DocumentPreviewModal;
